import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { emitAllrvkmpyrgtm20 as emitAll } from '../Channels.mjs';
import { CoroutineStart_ATOMIC_getInstancehid42awkwncc as CoroutineStart_ATOMIC_getInstance } from '../../CoroutineStart.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { produce3s4oh9balbl5b as produce } from '../../channels/Produce.mjs';
import { coroutineScope2qhrb6lhutwsn as coroutineScope } from '../../CoroutineScope.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { EmptyCoroutineContext_instance3dshdbvg42f79 as EmptyCoroutineContext_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/CoroutineContextImpl.mjs';
import { BufferOverflow_SUSPEND_getInstance1ucmryz5dsuc2 as BufferOverflow_SUSPEND_getInstance } from '../../channels/BufferOverflow.mjs';
import { get_classSimpleName2jgk6lzg9ft1 as get_classSimpleName } from '../../Debug.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function ChannelFlow$_get_collectToFun_$slambda_j53z2e(this$0) {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    yield* this$0.collectTo_qjwlth_k$(it, $completion);
    return Unit_instance;
  }), 1);
}
function ChannelFlow$collect$slambda($collector, this$0) {
  return constructCallableReference(($this$coroutineScope, $completion) => orPromise($completion, function *($completion) {
    yield* emitAll($collector, this$0.produceImpl_qjsv5i_k$($this$coroutineScope), $completion);
    return Unit_instance;
  }), 1);
}
var ChannelFlowClass;
function ChannelFlow() {
  if (ChannelFlowClass === VOID) {
    class $ {
      constructor(context, capacity, onBufferOverflow) {
        this.context_1 = context;
        this.capacity_1 = capacity;
        this.onBufferOverflow_1 = onBufferOverflow;
        // Inline function 'kotlinx.coroutines.assert' call
      }
      get_collectToFun_6oxkuu_k$() {
        return ChannelFlow$_get_collectToFun_$slambda_j53z2e(this);
      }
      get_produceCapacity_futzxg_k$() {
        return this.capacity_1 === -3 ? -2 : this.capacity_1;
      }
      produceImpl_qjsv5i_k$(scope) {
        return produce(scope, this.context_1, this.get_produceCapacity_futzxg_k$(), this.onBufferOverflow_1, CoroutineStart_ATOMIC_getInstance(), VOID, this.get_collectToFun_6oxkuu_k$());
      }
      *collect_aksokr_k$(collector, $completion) {
        return yield* coroutineScope(ChannelFlow$collect$slambda(collector, this), $completion);
      }
      additionalToStringProps_j3cp6l_k$() {
        return null;
      }
      toString() {
        var props = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(4);
        var tmp0_safe_receiver = this.additionalToStringProps_j3cp6l_k$();
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          props.add_utx5q5_k$(tmp0_safe_receiver);
        }
        if (!(this.context_1 === EmptyCoroutineContext_instance)) {
          props.add_utx5q5_k$('context=' + toString(this.context_1));
        }
        if (!(this.capacity_1 === -3)) {
          props.add_utx5q5_k$('capacity=' + this.capacity_1);
        }
        if (!this.onBufferOverflow_1.equals(BufferOverflow_SUSPEND_getInstance())) {
          props.add_utx5q5_k$('onBufferOverflow=' + this.onBufferOverflow_1.toString());
        }
        return get_classSimpleName(this) + '[' + joinToString(props, ', ') + ']';
      }
    }
    initMetadataForClass($, 'ChannelFlow', VOID, VOID, VOID, [1]);
    ChannelFlowClass = $;
  }
  return ChannelFlowClass;
}
//region block: exports
export {
  ChannelFlow as ChannelFlowvdfy82kdxy2m,
};
//endregion

//# sourceMappingURL=ChannelFlow.mjs.map
